import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, OnInit } from '@angular/core'

import { CartTableLineComponent } from '../../components/cart-table-line'
import { AddCartEvent, ApiOrder, ApiOrderline, ExtraCost } from '../../../cart/models/cart-models'
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { Setting } from '../../../core/models/setting';
import * as fromAuth from '../../../auth/reducers';
import { BackorderCounts } from '../../models/backorder-counts';

@Component({
  selector: 'app-cart-table',
  templateUrl: './template.html',
  styleUrls: ['./styles.scss'],
  entryComponents: [CartTableLineComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CartTableComponent  {
  LineComponent = CartTableLineComponent

  tenantName$: Observable<string>

  @Input() editable: boolean
  @Input() order: ApiOrder
  @Input() currency: string
  @Input() showDeliveryColumn: boolean
  @Input() quantityPicker: string
  @Input() showUomInfoForUoms: string[]
  @Input() backordercounts: BackorderCounts = {}
  @Input() discountType: string
  @Input() showFacets: string[]
  @Input() extraCosts: ExtraCost[]

  @Output() onLineChange = new EventEmitter<AddCartEvent>()
  @Output() onLineDelete = new EventEmitter<string>()
  @Output() onDetails = new EventEmitter<string>()

  constructor(private store: Store<any>) {
    this.tenantName$ = store
      .pipe(
        select(fromAuth.getCurrentTenantName)
      )
  }

  get orderDiscount(): string {
    return this.order.discount && this.order.discount + ' %'
  }

  get orderSubTotal(): number {
    // Backwards compatible fix when order.subTotalPrice is not available
    if (!this.order.subTotalPrice) {
      return this.order.totalPrice
    } else {
      return this.order.subTotalPrice
    }
  }

  get orderTotal(): number {
    return this.order.totalPrice
  }

  get lines(): ApiOrderline[] {
    return this.order.lines
  }

  get footerSpan(): number {
    return this.editable
      ? 9
      : 7
  }

  get showLineDiscount(): boolean {
    return this.discountType === 'linedisc'
  }

  openDetails(product: string) {
    this.onDetails.emit(product)
  }

  changeLine($event) {
    this.onLineChange.emit($event)
  }

  deleteLine($event) {
    this.onLineDelete.emit($event)
  }

  isLineInBackorder(line: ApiOrderline): boolean {
    const productBackorderCount = this.backordercounts[line.product.code] || 0

    return productBackorderCount > 0
  }

  get quantityPickerRelative(): boolean {
    return (this.quantityPicker && this.quantityPicker.toLowerCase() === 'relative')
  }

  get showUomValues(): boolean {
    return this.showUomInfoForUoms && this.showUomInfoForUoms.length > 0;
  }

  get showExtraCosts(): boolean {
    return this.extraCosts && this.extraCosts.length > 0;
  }

  getUomValueForUom(uom: string): number {
    if (this.order.quantitiesInUom && this.order.quantitiesInUom.length > 0) {
      const uomValue = this.order.quantitiesInUom.find(uomValue => uomValue.key === uom);

      if (uomValue) {
        return uomValue.value;
      }
    }

    return 0;
  }
}
